import { render, staticRenderFns } from "./StickerLayoutSource.vue?vue&type=template&id=03953164&scoped=true"
import script from "./StickerLayoutSource.vue?vue&type=script&lang=ts"
export * from "./StickerLayoutSource.vue?vue&type=script&lang=ts"
import style0 from "./StickerLayoutSource.vue?vue&type=style&index=0&id=03953164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03953164",
  null
  
)

export default component.exports